import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=48f93396&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=48f93396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f93396",
  null
  
)

export default component.exports